define([
    'text!index2021-base-line/component/product-list.html',
    // 'common/api',
    'jquery',
    '../common/utils',
    'css!index2021-base-line/component/product-list.css'

], function(
    tpl,
    // Api,
    $,Utils
){
    return {
        template: tpl,
        data: function(){
            return {
                windowWidth: 1280,
                itemShow: 1000
            };
        },
        props: {
            link: String,
            showNum: Number,
            productList: Array,
            productWidth: Number,
            isPC: Boolean,
            lineNum: Number
        },
        computed: {

        },
        created: function () {
            var obj = this;
            obj.windowWidth = $(window).width();

        },
        methods: {
            init: function () {
                var _this = this;
            },
            showMore: function () {
                var _this = this;
                _this.showNum += 1000;
            },
            enter: function (index) {
                var _this = this;
                _this.itemShow = index;
                // $('.produc-list-item-info').eq(index).addClass('itemShow')
            },
            leave: function () {
                var _this = this;
                _this.itemShow = 1000;
                // $('.produc-list-item-info').removeClass('itemShow')
            },
            uploadLog: function () {
                var _this = this;
                if(_this.lineNum==1){
                    window.open('http://fnji.com/temp/upload/1637549316_2012.pdf');//山脊线
                    // window.location.href="http://fnji.com/temp/upload/1637549316_2012.pdf";
                }else{
                    window.open('http://fnji.com/temp/upload/1637549267_5568.pdf');//大地线
                    // window.location.href="http://fnji.com/temp/upload/1637549267_5568.pdf";
                }
            }
        },
        mounted: function(){
            this.init();
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./index2021-base-line/component/product-list.js
// module id = 135
// module chunks = 10 11